import request from "../config/network/requestFinalCoursewareApiService";
// import request2 from "../config/network/requestFinalCoursewareApiService";
import request3 from "../config/network/requestMockApiService";

const request2 = request;
// 游戏场景列表
export function queryGameSceneList({ type_id }) {
  let url = `game_theme/index`;
  if (type_id) {
    url += `?page=1&per_page=9999&equal[type_id]=${type_id}`;
  }
  return request2({
    url,
    method: "get",
  });
}

// 游戏场景详情
export function queryGameSceneDetail({ id }) {
  return request2({
    url: `game_theme/${id}`,
    method: "get",
  });
}

// 新增游戏场景
export function addGameScene({
 name, type_id, cover_image_url, json_config_original, ...params
}) {
  return request2({
    url: `game_theme/store`,
    method: "post",
    data: {
 name, type_id, cover_image_url, json_config_original, ...params,
},
  });
}

// 修改游戏场景
export function updateGameScene({
 id, name, type_id, cover_image_url, json_config_original, ...params
}) {
  return request2({
    url: `game_theme/${id}`,
    method: "put",
    data: {
 name, type_id, cover_image_url, json_config_original, ...params,
},
  });
}

// 删除游戏场景
export function deleteGameScene({ id }) {
  return request2({
    url: `game_theme/${id}`,
    method: "delete",
  });
}

// 获取通用表单分类集合
export function queryGameSceneType() {
  return request2({
    url: `game_theme/second_version/get_types`,
    method: "get",
  });
}

// 新增通用表单分类
export function addGameType({ parent_type_id, name }) {
  return request2({
    url: `game_theme/second_version/add_type`,
    method: "post",
    data: { parent_type_id, name },
  });
}

// 移动游戏场景
export function moveGameScene({ id, type_id }) {
  return request2({
    url: `game_theme/second_version/move/${id}/${type_id}`,
    method: "put",
    data: { id, type_id },
  });
}
// 复制游戏场景
export function copyGameScene({ id }) {
  return request2({
    url: `game_theme/copy/${id}`,
    method: "post",
  });
}

// 素材启用/禁用状态切换（课中）
export function updateResource({ id, status_code }) {
  return request({
    url: `resource/resource_update_enabled_status/${id}/${status_code}`,
    method: "put",
  });
}

// 游戏包启用/禁用状态切换 (游戏包)
export function updateGamePack({ id, status_code }) {
  return request({
    url: `game_pack/resource_update_enabled_status/${id}/${status_code}`,
    method: "put",
  });
}

// 获取游戏分类集合
export function queryGameTypes() {
  return request({
    url: `game/second_version/get_types`,
    method: "get",
  });
}

// 新增游戏分类
export function addGameTypes({ name, parent_type_id }) {
  return request({
    url: `game/second_version/add_type`,
    method: "post",
    data: { name, parent_type_id },
  });
}

// 移动游戏
export function moveGameTypes({ id, type_id }) {
  return request({
    url: `game/second_version/move_game/${id}/${type_id}`,
    method: "put",
    data: { id, type_id },
  });
}

// 复制游戏
export function copyGameTypes({ id }) {
  return request({
    url: `game/copy/${id}`,
    method: "post",
  });
}

// 获取课后游戏包分类集合
export function queryGameAfter() {
  return request({
    url: `game_pack/second_version/get_types`,
    method: "get",
  });
}

// 新增课后游戏包分类
export function addGameAfter({ name, parent_type_id }) {
  return request({
    url: `game_pack/second_version/add_type`,
    method: "post",
    data: { name, parent_type_id },
  });
}

// 移动课后游戏包
export function moveGameAfter({ id, type_id }) {
  return request({
    url: `game_pack/second_version/move_game_pack/${id}/${type_id}`,
    method: "put",
    data: { id, type_id },
  });
}

// 复制课后游戏包
export function copyGameAfter({ id }) {
  return request({
    url: `game_pack/copy/${id}`,
    method: "post",
  });
}

// 复制课中游戏包
export function copyGame({ id }) {
  return request({
    url: `resource/copy/${id}`,
    method: "post",
  });
}
